var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "pa-3" },
    [
      _c(
        "v-row",
        [
          _c("v-col", [
            _c("h4", { staticClass: "bold" }, [_vm._v("Comentarios do Título")])
          ])
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              !_vm.comentarios.length
                ? _c("span", [_vm._v("Não há comentarios neste título")])
                : _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item-group",
                        _vm._l(_vm.comentarios, function(comentario, index) {
                          return _c(
                            "v-list-item",
                            { key: index, staticClass: "bg-comentario" },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _c("strong", [
                                      _vm._v(
                                        " " +
                                          _vm._s(comentario.email_user) +
                                          "(ID: " +
                                          _vm._s(comentario.id_user) +
                                          "/" +
                                          _vm._s(comentario.name_user) +
                                          ") - Criado em " +
                                          _vm._s(
                                            _vm.FormateData(
                                              comentario.dt_criacao
                                            )
                                          ) +
                                          ": "
                                      ),
                                      _c("i", { staticClass: "text-gray" }, [
                                        _vm._v(_vm._s(comentario.comentario))
                                      ])
                                    ])
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      ),
      _vm.addComentario && _vm.podeAdicionarComentario
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c(
                    "div",
                    { staticClass: "d-flex align-center mb-1" },
                    [
                      _c("span", { staticClass: "mr-1" }, [
                        _vm._v("Novo comentario")
                      ]),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "", "max-width": "320" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            attrs: {
                                              small: "",
                                              color: "grey darken-1"
                                            }
                                          },
                                          "v-icon",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [_vm._v(" mdi-information-outline ")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1728083939
                          )
                        },
                        [
                          _c("span", [
                            _vm._v(" Este comentário é interno e "),
                            _c("strong", [_vm._v("não é enviado ao cartório")]),
                            _vm._v(
                              ". Se precisar enviar alguma mensagem ao cartório, entre em contato com o contato da Rec. "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c("v-textarea", {
                    attrs: {
                      label: "Novo comentario",
                      outlined: "",
                      placeholder: "Escreva aqui seu comentario",
                      maxlength: _vm.MAX_COMENTARIO_LENGTH,
                      counter: _vm.MAX_COMENTARIO_LENGTH,
                      rules: [_vm.comentarioRule],
                      "error-messages": _vm.erroComentario,
                      hint:
                        "Este comentário é interno e não é enviado ao cartório.",
                      "persistent-hint": "",
                      rows: "4",
                      "auto-grow": ""
                    },
                    on: {
                      input: function($event) {
                        _vm.erroComentario = ""
                      }
                    },
                    model: {
                      value: _vm.novoComentario,
                      callback: function($$v) {
                        _vm.novoComentario = $$v
                      },
                      expression: "novoComentario"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.addComentario && _vm.podeAdicionarComentario
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { staticClass: "d-flex justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red", dark: "" },
                      on: {
                        click: function($event) {
                          _vm.addComentario = false
                          _vm.erroComentario = ""
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")]), _vm._v(" Cancelar ")],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-3",
                      attrs: {
                        loading: _vm.loadingSave,
                        color: "success",
                        disabled: !_vm.podeSalvar
                      },
                      on: {
                        click: function($event) {
                          return _vm.criarComentario()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-check")]), _vm._v(" Salvar ")],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      !_vm.addComentario && _vm.podeAdicionarComentario
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { staticClass: "d-flex justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function($event) {
                          _vm.addComentario = true
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("mdi-plus")]),
                      _vm._v(" Adicionar comentario ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }